import { render } from "./ImportacaoPedidoAgesul.vue?vue&type=template&id=0b26f12d"
import script from "./ImportacaoPedidoAgesul.vue?vue&type=script&lang=ts"
export * from "./ImportacaoPedidoAgesul.vue?vue&type=script&lang=ts"
script.render = render

export default script